import React, { useContext } from 'react';
import styled from 'styled-components';
import ShowOnMouseOverCss from '../../cssSnippets/ShowOnMouseOverCss';
import NavSideBarContext from '../../contexts/NavSideBarContext';

export const NavSectionDiv = styled.div<{
  hideBorderBottom?: boolean;
  $isOpen?: boolean;
}>`
  padding: ${(props) => (props.$isOpen ? '16px 16px 12px' : '8px 4px')};
  background-color: var(--color-bg-secondary);
  border-bottom: ${(props) =>
    props.hideBorderBottom
      ? 'unset'
      : `solid 1px var(--color-border-secondary)`};
  .v3-sidebar[data-hovered='true'] & {
    padding: 16px 16px 12px;
  }
  ${ShowOnMouseOverCss}
`;

export const NavSectionLabelDiv = styled.div<{ $isOpen?: boolean }>`
  padding-left: 8px;
  margin-bottom: 6px;
  display: ${(p) => (p.$isOpen === false ? 'none' : 'flex')};
  justify-content: space-between;
  align-items: center;
  .v3-sidebar[data-hovered='true'] & {
    display: flex;
  }

  span {
    color: var(--color-text-muted);
    font-family: Inter;
    font-weight: 500;
    font-size: 12px;
    font-style: normal;
    line-height: 14px; /* 107.692% */
    text-transform: capitalize;
    overflow: hidden;
    white-space: nowrap;
  }
`;

const NavSection = ({
  label,
  subLabel,
  hideBorderBottom,
  children,
}: {
  label?: string;
  subLabel?: JSX.Element;
  hideBorderBottom?: boolean;
  children?: JSX.Element | JSX.Element[];
}) => {
  const { isOpen } = useContext(NavSideBarContext);

  return (
    <NavSectionDiv hideBorderBottom={hideBorderBottom} $isOpen={isOpen}>
      {label && (
        <NavSectionLabelDiv $isOpen={isOpen}>
          <span>{label}</span>
          {subLabel}
        </NavSectionLabelDiv>
      )}
      {children}
    </NavSectionDiv>
  );
};

export default NavSection;
